export default __webpack_public_path__ + "static/media/van.d0cff45b.svg";